import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import DocFullScreenExample from '../UI/DocFullScreenExample';
import CoverExample from '../examples/Cover';
import CoverWithBackgroundExample from '../examples/CoverWithBackground';
import CoverWithFullWidthBackgroundExample from '../examples/CoverWithFullWidthBackground';
const CoverExampleSource = require('!!raw-loader!../examples/Cover');
const CoverWithBackgroundExampleSource = require('!!raw-loader!../examples/CoverWithBackground');
const CoverWithFullWidthBackgroundExampleSource = require('!!raw-loader!../examples/CoverWithFullWidthBackground');
export default class CoverPage extends React.Component {
    render() {
        return (<div>
                <Helmet title="Cover"/>

                <h3>Cover</h3>
                <DocFullScreenExample>
                    <CoverExample />
                </DocFullScreenExample>
                <pre>
                    <PrismCode className="language-jsx">{CoverExampleSource}</PrismCode>
                </pre>
                <div>
                    <h4>Cover Properties</h4>
                    <pre>
                        <PrismCode className="language-jsx">
                            {`
type Props = {|
  color: ?ColorListType,
  images: ?CoverImageType,
  title: string,
  titleSmall: boolean,
  description: ?string,
  leftButton: ?React.Element<typeof Button>,
  rightButton: ?React.Element<typeof LintButton>,
  children: ?React.ReactNode,
  className: string,
  withBackgroundImage: boolean,
  animated: boolean,
|};

Cover.defaultProps = {
  color: null,
  images: null,
  description: null,
  leftButton: null,
  rightButton: null,
  children: null,
  className: '',
  titleSmall: false,
  withBackgroundImage: false,
  animated: false,
};

`}
                        </PrismCode>
                    </pre>
                </div>
                <div>
                    <h3>Cover With Background</h3>
                    <DocFullScreenExample>
                        <CoverWithBackgroundExample />
                    </DocFullScreenExample>
                    <pre>
                        <PrismCode className="language-jsx">{CoverWithBackgroundExampleSource}</PrismCode>
                    </pre>
                </div>
                <div>
                    <h3>Cover With Full-width Background</h3>
                    <DocFullScreenExample>
                        <CoverWithFullWidthBackgroundExample />
                    </DocFullScreenExample>
                    <pre>
                        <PrismCode className="language-jsx">{CoverWithFullWidthBackgroundExampleSource}</PrismCode>
                    </pre>
                </div>
            </div>);
    }
}
